/* src/app/components/not-found/not-found.component.scss */
img {
  max-width: 500px;
  width: 80vw;
  margin: 100px auto 0;
  display: block;
}
/*# sourceMappingURL=not-found.component.css.map */
